<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">Second Reality</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#toc_id_4">Acknowledgement</a></li>
<li><a href="#/index_split_005#id_Toc146373207">Chapter One: Reality</a></li>
<li><a href="#/index_split_006#id_Toc146373208">Chapter Two: Ocean Petals</a></li>
<li><a href="#/index_split_007#id_Toc146373209">Chapter Three: Friends Rock</a></li>
<li><a href="#/index_split_008#id_Toc146373210">Chapter Four: Crazy Truths</a></li>
<li><span href="#/index_split_009#id_Toc146373211" title="Link target outside of Sample">Chapter Five: Sudden Death</span></li>
<li><span href="#/index_split_010#id_Toc146373212" title="Link target outside of Sample">Chapter Six: Instant Travel</span></li>
<li><span href="#/index_split_011#id_Toc146373213" title="Link target outside of Sample">Chapter Seven: Anxious Defeats</span></li>
<li><span href="#/index_split_012#id_Toc146373214" title="Link target outside of Sample">Chapter Eight: Knowing Home</span></li>
<li><span href="#/index_split_013#id_Toc146373215" title="Link target outside of Sample">Chapter Nine: Fingertips</span></li>
<li><span href="#/index_split_014#id_Toc146373216" title="Link target outside of Sample">Chapter Ten: The Tunnel</span></li>
<li><span href="#/index_split_015#id_Toc146373217" title="Link target outside of Sample">Chapter Eleven: Breathe Slowly</span></li>
<li><span href="#/index_split_016#id_Toc146373218" title="Link target outside of Sample">Chapter Twelve: I’ll Come</span></li>
<li><span href="#/index_split_017#id_Toc146373219" title="Link target outside of Sample">Chapter Thirteen: But It Does</span></li>
<li><span href="#/index_split_018#id_Toc146373220" title="Link target outside of Sample">Chapter Fourteen: Control</span></li>
<li><span href="#/index_split_019#id_Toc146373221" title="Link target outside of Sample">Chapter Fifteen: Like an Animal</span></li>
<li><span href="#/index_split_020#id_Toc146373222" title="Link target outside of Sample">Chapter Sixteen: My Awakening</span></li>
<li><span href="#/index_split_021#id_Toc146373223" title="Link target outside of Sample">Chapter Seventeen: My Turn</span></li>
<li><span href="#/index_split_022#id_Toc146373224" title="Link target outside of Sample">Chapter Eighteen: Who I Am</span></li>
<li><span href="#/index_split_023#id_Toc146373225" title="Link target outside of Sample">Chapter Nineteen: Yes</span></li>
<li><span href="#/index_split_024#id_Toc146373226" title="Link target outside of Sample">Epilogue</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f3bf7fca